import { render, staticRenderFns } from "./common-toast.vue?vue&type=template&id=8a8b871c&scoped=true&"
import script from "./common-toast.vue?vue&type=script&lang=js&"
export * from "./common-toast.vue?vue&type=script&lang=js&"
import style0 from "./common-toast.vue?vue&type=style&index=0&id=8a8b871c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8b871c",
  null
  
)

export default component.exports